import AuthService from '@forwardflow/services/AuthService'
import LocalStorage from '@forwardflow/services/LocalStorage'
import { Button, TextField } from '@forwardflow/ui'
import { useUserNavigation } from '@forwardflow/hooks/customHooks/useUserNavigation'
import { Form } from 'antd'
import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

export const SigninForm = () => {
   const [isLoading, setLoading] = useState<boolean>(false)
   const [formError, setFormError] = useState<string>('')
   const location = useLocation()
   const [form] = Form.useForm()
   const { navigateUser, getCurrentOrgId } = useUserNavigation()

   const handleSubmit = async () => {
      try {
         setLoading(true)
         const values = await form.validateFields()
         const data = await AuthService.apiSignin(values)
         LocalStorage.put('access_token', data.accessToken)

         // Fetch user data to determine correct navigation path

         // Get the current organization ID using the shared logic
         const currentOrgId = await getCurrentOrgId()
         // Navigate user to the appropriate route based on their state
         await navigateUser({
            currentOrgId,
            searchParams: location.search,
         })
      } catch (error: unknown) {
         if (
            error instanceof Error &&
            'response' in error &&
            typeof error.response === 'object' &&
            error.response !== null &&
            'status' in error.response &&
            error.response.status === 404
         ) {
            setFormError(
               'User not found. Please check your credentials or sign up.'
            )
         } else {
            setFormError('An error occurred during sign in. Please try again.')
         }
      } finally {
         setLoading(false)
      }
   }
   return (
      <>
         <Form
            layout="vertical"
            form={form}
            initialValues={{}}
            onFinish={handleSubmit}
            className="w-full text-left text-white"
            autoComplete="off"
         >
            <TextField
               name="email"
               label="Email"
               formItemClassName="w-full ff-white-label"
               placeholder="Enter your email"
               isRequired
               validateEmail
               errorMessage="Please enter a valid email"
            />

            <TextField
               name="password"
               type="password"
               label="Password"
               placeholder="Enter your password"
               formItemClassName="w-full ff-white-label"
               isRequired
               errorMessage="Please enter password"
            />
            <Link
               to="/forgot-password"
               className="text-white/70 hover:text-white/50"
            >
               Forgot Password?
            </Link>
            <Button
               isLoading={isLoading}
               type="submit"
               className="!mt-3 mb-10 h-[60px]"
            >
               Sign in
            </Button>
            {formError && (
               <div className="text-[#ff4d4f] mb-4 -mt-4">{formError}</div>
            )}
         </Form>
      </>
   )
}
